import type { Me } from '@/api/me';

/**
 * Display name from the `/me` virtual account row's `sharedBy`, then the owner, then sponsors; `''` when
 * none has one. A caller renders `''` through its own fallback (`personName`'s "A member", or the
 * pitch's own phrase), never as an empty name.
 */
export function sponsorName(me: Me, virtualAccountId: number | null): string {
  const row =
    virtualAccountId === null
      ? me.virtualAccounts.find((virtualAccount) => !virtualAccount.mine)
      : me.virtualAccounts.find((virtualAccount) => virtualAccount.id === virtualAccountId);
  const sharedBy = row?.sharedBy?.trim();
  if (sharedBy) return sharedBy;
  const owner = row?.ownerDisplayName?.trim();
  if (owner) return owner;
  const sponsor = me.sponsors.find((person) => (person.displayName ?? '').trim().length > 0);
  return sponsor?.displayName?.trim() ?? '';
}

/** An in-app path only. External and protocol-relative values are dropped. */
export function safeInternalPath(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
  return value;
}
